export const FILE_NAME_DATE_FORMAT = 'YYYY-MM-DD';
export const FILE_NAME = '_EY_Canvas_Client_Portal_';
export const clientRequestHeaders = {
	engagementName: 'engagementName',
	engId: 'engId',
	reqItemNumber: 'reqItemNumber',
	reqTitle: 'reqTitle',
	priority: 'priority',
	receivedDate: 'receivedDate',
	status: 'status',
	dueDate: 'dueDate',
	overdue: 'overdue',
	eyContact: 'eyContact',
	assignedTo: 'assignedTo'
};
